import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Table, Tag } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../components";
import { searchLength } from '../../constants';
import { Links } from '../../helpers/Links';
import { DsNgayNghiPagingResponse, NgayNghi } from "../../models/ngaynghi/NgayNghi";
import { timKiemDSNgayNghi } from "../../services/ngaynghi";
import LoaiNgayNghiSelectBox from "../utils/LoaiNgayNghiSelectBox";

const DanhSachNgayLe = () => {
    const [danhsach, setDanhSach] = useState<DsNgayNghiPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [idLoaiNgayNghi, setIdLoaiNgayNghi] = useState<number>(0);
    const [reloadPage, setReloadPage] = useState<boolean>(true);

    const timkiem = async (idLoaiNgayNghi: number, tuKhoa: string, start: number, length: number, page: number) => {
        try {

            const temp = await timKiemDSNgayNghi(idLoaiNgayNghi, tuKhoa, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
        }
        catch (error: any) {
        };
    }

    const renderDate = (text: string) => {
        const date = new Date(text);
        const formattedDate = date.toLocaleDateString('vi-VN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        return <span>{formattedDate}</span>;
    };

    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            timkiem(0, tuKhoa, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idLoaiNgayNghi, tuKhoa, 0, 0, 0)        }
    };
    return (<section>
        <ContentHeader title="Quản lý ngày nghỉ, làm bù" />
        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Form>
                    <LoaiNgayNghiSelectBox
                        onChange={(e) => setIdLoaiNgayNghi(e.target.value)}
                    />
                </Form>
            </Col>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập lý do" onChange={(e) => setTuKhoa(e.target.value)}
                    onKeyPress={handleKeyPress} />
            </Col>
            <Col span={4}>
                <Space>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(idLoaiNgayNghi, tuKhoa, 0, 0, 0)}>
                        Tìm kiếm
                    </Button>
                </Space>
            </Col>
            <Col span={4}>
                {
                    <Link className="hrm-btn float-right hrm-btn-warning" to={Links.NgayNghi.ChiTiet} > <PlusOutlined rev="" />Thêm mới </Link>
                }
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row gutter={8}>
                        <Col span={24}>
                            <Table
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={danhsach?.data}
                            >
                                <Column
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column title="Từ ngày" dataIndex="tuNgay" key="tuNgay" render={renderDate} />
                                <Column title="Đến ngày" dataIndex="denNgay" render={renderDate} />
                                <Column title="Lý do" dataIndex="lyDo" key="lyDo" />
                                <Column title="Loại ngày nghỉ"
                                    key="trangThai"
                                    render={(value: NgayNghi, record, index) =>
                                    (
                                        value.idLoaiNgayNghi === 1 ? (
                                            <Tag color="green">{value.tenLoaiNgayNghi}</Tag>
                                        ) : value.idLoaiNgayNghi === 2 ? (
                                                <Tag color="blue">{value.tenLoaiNgayNghi}</Tag>
                                            ) : value.idLoaiNgayNghi === 3 ? (
                                                <Tag color="warning">{value.tenLoaiNgayNghi}</Tag>
                                            ) : (
                                                    <Tag color="red">{value.tenLoaiNgayNghi}</Tag>
                                        )
                                    )
                                    }
                                />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Link key={"link" + index} className="hrm-btn hrm-btn-sm  btn-primary" to={`${Links.NgayNghi.ChiTiet}?id=${value?.id}`}>Xem</Link>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default DanhSachNgayLe;